import React from 'react';
import styled from 'styled-components';

const SectionWrapper = styled.section`
 
 
  box-sizing: border-box;
  width:60%;
  margin: 0 auto;
  padding:5% 0% 5% 0%;

  @media (max-width: 500px) {
    width:90%;
    padding: 0%;
  }
`;


const Title = styled.h2`
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 70px;
  letter-spacing: 0.05em;
  color: #FFFFFF;
  
  


  span{
    color: #FFF56A;
  }

  @media (max-width: 500px) {
    width:70%;
    font-size: 32px;
    line-height: 40px;
    padding:20% 0% 10% 0%;
    margin: 0 auto;

  }


`;

const GoalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
  position: relative; 

  @media (max-width: 500px) {
    flex-direction: row; 
    gap: 8px;


  }
`;

const GoalCard = styled.div`
  position: relative;
  flex: 1;
  max-width: calc(33% - 2px);
  background-color: transparent;
  border-radius: 30px;
  text-align:center;

  
  overflow: hidden;
  margin-bottom: 24px;



  @media (max-width: 500px) {
    box-sizing: border-box;
    flex: calc(100% - 0px);
    max-width: 100%;
    margin-bottom: 8px; 
 
  }




`;



const GoalImage = styled.img`
  width: 40%;
  height: auto;
  object-fit: cover;
  padding:10% 30% 5% 30%;
  
  

  @media (max-width: 500px) {
   
    max-width: 100%; /* 調整圖片最大寬度 */
    height: auto; /* 確保高度按比例縮放 */
    padding:5% 5% 0% 5%;
  }
`;

const GoalTitle = styled.h2`
  text-align: center;
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 41px;
  letter-spacing: 0.05em;
  color: #FFFFFF;

  margin-top:0px;


  @media (max-width: 500px) {
    width:70%;
    font-size: 32px;
    line-height: 40px;
    padding:5% 0% 0% 0%;
    margin: 0 auto;

  }


`;


const GoalText = styled.p`
  font-weight: 400;
  font-size: 18px;
  line-height: 32px;
  color: #AFAFAF;
  align-items: center;
  padding: 0% 10% 0% 10%;
  gap: 8px;
  margin-bottom: 16px;
  position: relative; 

  @media (max-width: 500px) {
    font-size: 14px;
    padding:0% 5% 5% 5%;
    gap: 0px;
    line-height: 24px;
 
  }



`;





const DIDSection4 = () => (
  <SectionWrapper>
    
    <Title>DID 分散式身分的優勢<span>.</span></Title>
    <GoalContainer>
      {/* Goal 1 */}
      <GoalCard>
        <GoalImage src="/images/DIDSec4_1.png" alt="Goal 1" />
        <GoalTitle>超韌組織憑證</GoalTitle>
        <GoalText>發行憑證代幣予國內組織，示範未來與國際個人、企業、組織及政府單位快速對接的可能性。</GoalText>
        
       
      </GoalCard>

      {/* Goal 2 */}
      <GoalCard>
        <GoalImage src="/images/DIDSec4_2.png" alt="Goal 2" />
        <GoalTitle>Taiwan DID 實驗計畫</GoalTitle>
        <GoalText>串接行動自然人身分憑證，為全球示範政府核發國家身分對接分散式身分的可能。</GoalText>
     
      </GoalCard>

      {/* Goal 3 */}
      <GoalCard>
        <GoalImage src="/images/DIDSec4_3.png" alt="Goal 3" />
        <GoalTitle>河流關懷介面</GoalTitle>
        <GoalText>以曾文溪為例，為河流建立身分與對話介面，成為人們的關懷對象，促進永續社會。</GoalText>
   
      </GoalCard>

  
    </GoalContainer>
  </SectionWrapper>
);

export default DIDSection4;
